<template>
  <div>
    <Title :title="'日换电次数'" :isActiveSec="true"></Title>
    <Chart :cdata="cdata" :width="style.width" :height="style.height"/>
  </div>
</template>

<script>
import Chart from '../chart.vue';
import Title from '../../title';
import { indexLeft } from '@/api/indexLeft';
import { dataInterface } from '@/api/dataInterfaceApi';


export default {
  data () {
    return {
      cdata: {
        category: [],
        rateData: [],
        id:"userAddChart",
        legendData:[{
              name:"商用",
              icon: 'roundRect',
            }, {
              name:"乘用",
              icon: 'roundRect',
        }],
        series:[
            {
              name: "商用",
              type: "line",
              smooth: true,
              // showAllSymbol: true,
              // symbol: "emptyCircle",
              symbolSize: 1,
              // yAxisIndex: 1,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#36A1FF" },
                    { offset: 1, color: "#1968FF" }
                ])
              },
              data: []
            },
            {
              name: "乘用",
              type: "line",
              smooth: true,
              // showAllSymbol: true,
              // symbol: "emptyCircle",
              symbolSize: 1,
              // yAxisIndex: 1,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#9DF590" },
                    { offset: 1, color: "#6BE4B2" }
                ])
              },
              data:  []
            },
        ]
      },
      style:{
        width: '500',
        height: '180'
      }
    };
  },
  components: {
    Chart,
    Title,
  },
  mounted () {
    
  },
  methods: {
    getData(data){
      this.selectPowerChangeNumOfDay(data);
    },
    selectPowerChangeNumOfDay(data={}){
      let _this = this;
      let params = {};
				if(data){
				//建设中--省市区
				params = {
					"enCode":"TiDB-shengshiqu-rihuandiancishu",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-rihuandiancishuqushi"//全国
				}
			}

      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          console.log("日换电",res)
          let comm_num  = [];
          let pass_num  = [];
          let xList = [];
          res.forEach(item=>{
            comm_num.push(item.comm_num);
            pass_num.push(item.pass_num);
            xList.push(item.cur_date);
          })
          this.cdata.series[0].data = comm_num ;//活跃度
          this.cdata.series[1].data = pass_num;//活跃度
          this.cdata.category = xList;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
};
</script>

<style lang="scss" scoped>
</style>